// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"70":"de8108b6","3596":"c3f23abe"}[chunkId] + ".js";
};